import * as React from "react";

import "./hidden-field.scss";

import {TextareaAutosize} from "@Common/libs/react-autosize-textarea/textarea-autosize";
import {bindInput}        from "@Common/react/bind-input";

import {getInfoTip} from "../common/get-info-tip";

const h:any = React.createElement;

export const HiddenField = ({xdQaName, textField, cc}) => (
    <div className="relative hidden-field-5vk">
        {h(TextareaAutosize, {
            "xd-qa-type": "textarea",
            "xd-qa-name": xdQaName,
            style: {display: 'none'},
            ...bindInput(textField),
        })}
        {getInfoTip(textField, cc.sourceData)}
    </div>
);
